import HttpService from "../../constant/Api";
import { message } from "antd";
import { v4 as uuidv4 } from "uuid";

const API = "v1/message";
const Session_API = "v1/session";

export const getMessagesService = (
  sessionID,
  params = { pageNumber: 1, pageSize: 15 }
) => {
  if (!sessionID) {
    message.error("Session ID not found");
  }
  return HttpService.get(`${API}/${sessionID}`, { params });
};

export const sendMessagePWAService = (sessionID, type, params, config) => {
  if (!sessionID) {
    message.error("Session ID not found");
  }

  if (!params || (params && Object.keys(params).length === 0)) {
    message.error("params not found");
  }

  return HttpService.post(`${API}/send/pwa/${sessionID}/${type}`, params, {
    ...config,
  });
};

export const sendMessageService = (sessionID, type, params, config) => {
  if (!sessionID) {
    message.error("Session ID not found");
  }

  if (!params || (params && Object.keys(params).length === 0)) {
    message.error("params not found");
  }

  const data = new FormData();
  for (let prop in params) {
    if (params.hasOwnProperty(prop)) {
      if (prop === "file") {
        const id = uuidv4();
        data.append(prop, params[prop], `${id}--${params[prop]["name"]}`);
      } else {
        data.append(prop, params[prop]);
      }
    }
  }

  return HttpService.post(`${API}/send/${sessionID}/${type}`, data, {
    ...config,
    headers: {
      accept: "*/*",
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getStatisticsService = (sessionID) => {
  if (!sessionID) {
    message.error("Session ID not found");
  }
  return HttpService.get(`v1/session/statistic/${sessionID}`);
};

export const deleteMessageService = (sessionId, messageId) => {
  if (!sessionId) {
    message.error("Session ID not found");
  } else if (!messageId) {
    message.error("message ID not found");
  }
  return HttpService.delete(`${API}/${sessionId}/${messageId}`);
};

export const getFileService = (fileId) => {
  if (!fileId) {
    message.error("fileId not found");
  }
  return HttpService.get(`v1/file/${fileId}`);
};

export const startCallSessionService = (id) => {
  return HttpService.post(`${Session_API}/start-call/${id}`);
};

export const endCallSessionService = (id) => {
  return HttpService.post(`${Session_API}/end-call/${id}`);
};
